import { ApiBind, CommonSearchParam } from "@app/core/models/common-search-param.model";

/**
 * 広告リクエストフォーマットテンプレート検索パラメータクラス
 * @remarks
 * 広告リクエストフォーマットテンプレート検索パラメータ情報を格納するクラス
 */
export class AdRequestFormatTemplateSearchParam extends CommonSearchParam {

    constructor(
        isAllox?: boolean,
    ) {
        super();
        this.isAllox = isAllox;
    }

    // Allox管理であるかどうか
    @ApiBind({ column: 'is_allox' })
    isAllox: boolean;

}
